import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import clsx from 'clsx';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import AccountSelect from "../../components/AccountSelect";
import News from "../../components/News";
import TableGirls from "../TableGirls";
import TablePayment from "../../components/TablePayment";
import {connect} from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import {withRouter, Switch, Route, Redirect} from "react-router-dom";

import {changePassword, logout} from "../../services/authService";
import Contacts from "../Contacts";
import Stat from "../Stat";
import ActivationHistory from "../ActivationHistory";
import ChangePassword from "../../components/Popups/ChangePassword";
import Tarifs from "../Tarifs";
import IconButton from "@material-ui/core/IconButton";
import {Button} from "@material-ui/core";
import Whitelist from "../Whitelist";
import AlertMessage from "../../components/AlertMessage";
import {getMonth} from "../../utils/functions";

const drawerWidth = 240;


function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: 'f7f9fa',
    display: 'flex',
    height: 224,
  },
  menuButton: {
    position: 'fixed',
    left: '30px',
    marginRight: theme.spacing(2),
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,


  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  toolbar: theme.mixins.toolbar,
  // content: {
  //     flexGrow: 1,
  //     backgroundColor: theme.palette.background.default,
  //     padding: theme.spacing(3),
  // },
  wrapper: {
    textTransform: 'none',

  },
  tabLabel: {
    flexDirection: 'unset',
    justifyContent: 'left',
    marginLeft: '15px'
  },
  indicator: {
    left: 0
  },
  logo: {
    display: 'flex',
    alignContent: "center",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  },
  hide: {
    display: 'none',
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
});

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      changePasswordPopupOpen: false,
      lastNewsOpen: null,
    }
  }


  handleChange = (event, newValue) => {
    this.props.history.push(this.getRoutes()[newValue].path);
  };

  getRoutes = () => {
    const {user, news} = this.props;
    return [
      {path: '/', exact: true, label: 'Главная', render: () => <TableGirls/>},
      {path: '/recommendations', label: 'Рекомендации агентства', render: () => <Whitelist/>},
      {path: '/payments', label: 'История платежей', render: () => <TablePayment data={user.payments || []}/>},
      {path: '/activation-history', label: 'История расходов', render: () => <ActivationHistory/>},
      {path: '/stat', label: 'Статистика', render: () => <Stat/>},
      {
        path: '/tariffs', label: 'Тарифы',
        render: () => (
          <React.Fragment>
            <Typography component={'div'} style={{marginBottom: '30px', fontSize: '2rem'}}>
              Тарифы
            </Typography>
            <Tarifs discounts={user.discounts || []}/>
          </React.Fragment>
        )
      },
      {
        path: '/news',
        label: (
          <div style={{display: 'flex'}}>
            <div onClick={this.setCheckedNews}>Новости</div>
          </div>
        ),
        render: () => (
          <React.Fragment>
            <Typography component={'span'} style={{fontWeight: 'bold'}}>Новости</Typography>
            <News items={news || []}/>
          </React.Fragment>
        )
      },
      {
        path: '/contacts', label: 'Контакты',
        render: () => (
          <React.Fragment>
            <h2>Контакты</h2>
            <Contacts/>
          </React.Fragment>
        )
      },
    ];
  };

  setCheckedNews = () => {
    !!this.props.news[0] && localStorage.setItem('last_news', this.props.news[0].hash);
  }

  handleDrawerOpen = () => {
    this.setState({open: true});
  };

  handleDrawerClose = () => {
    this.setState({open: false});
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!prevProps.news.length && this.props.news.length) {
      let needToShowNewNews = (!localStorage.getItem('last_news') && !!this.props.news[0]) || (!!this.props.news[0] && localStorage.getItem('last_news') != this.props.news[0].hash)
      console.log('OOOOOOOO', needToShowNewNews)
      if (needToShowNewNews) {
        this.setState({lastNewsOpen: this.props.news[0]})
        this.setCheckedNews()
      }
    }
  }


  render() {


    console.log('EEEEEEEEEEEEEEE', this.props.news)
    const {classes, dispatch, user, userId, location} = this.props;
    const {open, lastNewsOpen} = this.state;
    const routes = this.getRoutes();
    const value = Math.max(
      routes.findIndex(route => route.exact ? location.pathname === route.path : location.pathname.startsWith(route.path)),
      0
    );
    return (
      <div className={classes.root}>


        <CssBaseline/>
        <Drawer
          className={classes.drawer}
          variant="persistent"
          open={open}
          classes={{
            paper: classes.drawerPaper,
          }}
          style={{width: open ? drawerWidth : 0}}
          anchor="left"
        >

          <div className={clsx(classes.drawerHeader, !open && classes.hide)}>
            <IconButton onClick={this.handleDrawerClose}>
              <ChevronLeftIcon/>
            </IconButton>
          </div>
          <div className={classes.toolbar}/>
          <div className={classes.logo}>
            <a target={'_blank'} href={'https://help-chat.com.ua'} style={{display: 'contents'}}>
              <img src={'/space/icon-256.png'} style={{width: '50%'}}/>
            </a>
            <br/>
            <AccountSelect
              settingsFunc={() => {
              }}
              changeAccountFunc={() => {
              }}
              logoutFunc={() => {
                dispatch(logout())
              }}
              changePassword={() => this.setState({changePasswordPopupOpen: true})}
              user={user}
              userId={userId}
            />
          </div>
          <Divider/>

          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={value}
            onChange={this.handleChange}
            aria-label="Vertical tabs example"
            className={classes.tabs}
            indicatorColor={"primary"}
            TabIndicatorProps={{className: classes.indicator}}
          >
            {routes.map((route, index) => (
              <Tab
                key={route.path}
                style={{backgroundColor: value === index ? '#95c61c' : '', color: value !== index ? 'black' : '#fff'}}
                classes={{wrapper: classes.tabLabel}}
                className={classes.wrapper}
                label={route.label}
                {...a11yProps(index)}
              />
            ))}

          </Tabs>

        </Drawer>

        <main style={{backgroundColor: 'f7f9fa', width: '100%',}}>
          <Button
            variant={'contained'}
            color="primary"
            aria-label="open drawer"
            onClick={this.handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon/>
          </Button>
          <Box p={3} style={{backgroundColor: 'f7f9fa', width: '100%',}}>
            <Switch>
              {routes.map(route => (
                <Route key={route.path} path={route.path} exact={route.exact}>
                  {route.render()}
                </Route>
              ))}
              <Redirect to="/"/>
            </Switch>
          </Box>

        </main>
        <ChangePassword
          onSuccess={(oldPassword, newPassword) => dispatch(changePassword(oldPassword, newPassword))}
          onClose={() => this.setState({changePasswordPopupOpen: false})}
          open={this.state.changePasswordPopupOpen}
        />
        {lastNewsOpen && <AlertMessage
          title={new Date(lastNewsOpen.publish_date).getDate() + ' ' + getMonth(new Date(lastNewsOpen.publish_date)) + ' ' + new Date(lastNewsOpen.publish_date).getFullYear()}
          content={lastNewsOpen.body}
          open={!!this.state.lastNewsOpen}
          handler={() => this.setState({lastNewsOpen: null})}
        />}

      </div>
    );
  }

}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth.user,
    userId: state.Auth.user.id,
    clientCosts: state.Clients.clientCosts,
    news: state.Clients.news,
  }
}

export default withRouter(connect(mapStateToProps)(withStyles(styles)(Sidebar)))